export default "__VITE_ASSET__CLOPv2dz__"